export default __webpack_public_path__ + "assets/images/logo_1.39816d.webp";